<template>
  <div>
    <div
      v-if="!params.node.group && (displayValue === '-' || params.data.strategy === 'MLO')"
      class="c-open-order-entry"
    >
      <c-tick-flash :value="params.value">
        <span aria-hidden="true">{{ displayValue }}</span>
      </c-tick-flash>
      <span class="sr-only">{{ this.srValue }}</span>
    </div>
    <c-open-order-entry
      v-else-if="!params.node.group"
      :action="action"
      :limit="params.value"
      :ric="ric"
      :ticketType="ticketType"
      :quantity="params.data.quantity"
      :accountId="accountId"
      ref="oeButton"
      :isFractional="isFractional"
    >
      <span class="sr-only">{{ getAriaText(params) }}</span>
      <c-tick-flash :value="params.value">
        {{ displayValue }}
      </c-tick-flash>
    </c-open-order-entry>
  </div>
</template>

<script>
import Vue from 'vue';
import CTickFlash from '@custom/CTickFlash';
import COpenOrderEntry from '@custom/COpenOrderEntry';
import { getAriaText } from '@utils/helpers';
export default Vue.extend({
  name: 'quote-renderer',
  components: {
    CTickFlash,
    COpenOrderEntry
  },
  computed: {
    isArrayValue() {
      return Array.isArray(this.params.valueFormatted);
    },
    displayValue() {
      return this.isArrayValue ? this.params.valueFormatted[this.params.data.index] : this.params.valueFormatted;
    },
    srValue() {
      if (this.isArrayValue) {
        return this.params.data.allTickerArray.join(', ') + ' , ' + this.params.valueFormatted.join(' ');
      }
      return this.params.valueFormatted;
    },
    accountId() {
      if (this.params.context && this.params.context.wid && this.params.context.wid.startsWith('holdings'))
        return this.params.context.selectedAccountId;
      return '';
    },
    action() {
      return this.params.colDef.field.includes('BID') ? 'bid' : 'ask';
    },
    ric() {
      return (
        this.params.data.ric ||
        this.params.data['q.RIC'] ||
        this.params.data.underlyingRic ||
        this.params.node.id.split('/').pop()
      );
    },
    ticketType() {
      switch (this.params.data['q._TYPE']) {
        case 'OPT':
          return 'option';
        case 'STO':
          return 'stock';
        case 'IND':
          return 'index';
        default:
          return '';
      }
    },
    //Only in case of Order Status Fractional Bid Ask TD wants to open a Stock order entry, all other cases its Fractional
    isFromOrderStatusBidAsk() {
      return this.params.data.orderKey && ['bid', 'ask'].includes(this.action);
    },
    isFractional() {
      if (this.params.data.isFractional && this.isFromOrderStatusBidAsk) return false;
      return this.params.data.isFractional;
    }
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return true;
    },
    onKeyDown(e) {
      const enter = e.keyCode === 13;
      const tab = e.keyCode === 9;

      if (this.$el.tagName === 'BUTTON') {
        const buttonInFocus = e.target.tagName === 'BUTTON';
        if (!buttonInFocus && (tab || enter)) {
          if (this.$refs.oeButton) this.$refs.oeButton.$el.focus();
          e.preventDefault();
        } else if (buttonInFocus && e.keyCode === 27) {
          this.params.eGridCell.focus();
          e.preventDefault();
        }
      }
    }
  },
  created() {
    this.params.eGridCell.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    this.params.eGridCell.removeEventListener('keydown', this.onKeyDown);
  }
});
</script>
